import { useSelector } from 'react-redux';
import I18n from 'i18n-js';

// @ts-ignore lib
import { radarUserDataPlainSelector } from '@lootboy/lib/slices/radarUserProfile';

import { Divider } from '~/components/atoms/Divider';

import useBooleanState from '~/hooks/useBooleanState';
import { MenuOption } from '~/popups/MenuPopup/MenuOptionsGroup/MenuOption';

import { ReactComponent as ResetIcon } from '~/assets/images/iconsLibrary/refresh.svg';

import { ResetChatRadarDialog } from './ResetChatRadarDialog';

import styles from './ResetChatRadar.module.scss';

export function ResetChatRadar(): JSX.Element {
  // @ts-ignore lib
  const { userData } = useSelector(radarUserDataPlainSelector) || {};

  const [
    isResetDialogOpened,
    { setFalse: closeResetDialog, setTrue: openResetDialog },
  ] = useBooleanState();

  return (
    <>
      {isResetDialogOpened && <ResetChatRadarDialog close={closeResetDialog} />}
      {!!userData?.id && (
        <>
          <MenuOption
            className={styles.resetButton}
            labelClassName={styles.label}
            label={I18n.t('MenuView_profile_resetradar')}
            onClick={openResetDialog}
          >
            <ResetIcon className={styles.icon} />
          </MenuOption>
          <Divider className={styles.divider} />
        </>
      )}
    </>
  );
}
